// src/composables/useViewportHeight.js
export function useViewportHeight() {
	const setVh = () => {
		document.documentElement.style.setProperty('--100vh', `${window.innerHeight}px`);
	};

	setVh(); // Set on load

	window.addEventListener('resize', setVh); // Update on resize

	// Optional cleanup for SPA route changes or component lifecycle
	return () => {
		window.removeEventListener('resize', setVh);
	};
}
